import pythonApiClient from "./pythonBaseApi";

const impresionTicketApi = {
  /**
   * Obtener todas las secciones y tipos de secciones de un ticket para mantenimiento
   * @param {number} proyectoId - ID del proyecto
   * @returns {Promise} Lista de secciones y sus tipos
   */
  getSecciones: (proyectoId) => {
    return pythonApiClient.get(`/impresion/ticket/secciones/${proyectoId}`);
  },

  /**
   * Actualizar las secciones de forma masiva (descripción, posición, activo, tipo)
   * @param {number} proyectoId - ID del proyecto
   * @param {Array} secciones - Arreglo de secciones editadas
   * @returns {Promise} Resultado de la actualización
   */
  updateSecciones: (proyectoId, secciones) => {
    return pythonApiClient.put(`/impresion/ticket/secciones/${proyectoId}`, { secciones });
  }
};

export default impresionTicketApi;
